import { messages } from '../consts';
/**
 * validate Wireless Sales SDK response.
 * @memberof posPlatform.wireless
 * @function validateSsdkResponse
 * @returns {Promise} Promise object represents response
 */
export default function validateSsdkResponse(response) {
    const opErrorCode = window.WS_GetLastOperationErrorCode();

    if (opErrorCode === window.WS_LastOperationErrorCode_None) return;

    throw Object.assign(
        new Error(opErrorCode || messages.invalidResponse),
        { response },
    );
}